<template>
  <div class="vacuumPanels" :key="`tab_content_6` + $store.state.calculatorData.calculatorPages[6].disabled">
   <div class="row">
      <div class="col-md-7">
        <h2>{{ $t(`vacuumPanels.title`)}}</h2>
      </div>
      <div class="col-md-5 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

  <b-button @click="explanationClick()" v-b-toggle.explanation-content-vacuumPanels variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
  <b-collapse id="explanation-content-vacuumPanels" class="explanation-content">
    <b-card>
      <p v-html="$t(`vacuumPanels.infoText`)"></p>
      <p class="d-md-none font-size-small radio-info-text">
        <b-badge variant="warning">i</b-badge>
        Wählen für weitere Informationen
      </p>
    </b-card>
  </b-collapse>
    <div>
      <div v-if="$store.state.calculatorData.warnings.vacuumPanels">
        <div v-if="elementForm === 'jak' || elementForm === 'jakp'" class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" :type="`vip_`+elementForm" :disabled="($store.state.calculatorData.warnings.vacuumPanels.wIsToSmall || $store.state.calculatorData.warnings.vacuumPanels.cIsToSmall)" />
          <StoRadio step="vacuumPanels" :type="`novip_`+elementForm" />
        </div>
        <div v-else class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" :type="`vip_`+elementForm" :disabled="true" />
          <StoRadio step="vacuumPanels" :type="`novip_`+elementForm" />
        </div>
      </div>
      <div v-else>
        <div v-if="elementForm === 'jak' || elementForm === 'jakp'" class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" :type="`vip_`+elementForm" />
          <StoRadio step="vacuumPanels" :type="`novip_`+elementForm" />
        </div>
        <div v-else class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" :type="`vip_`+elementForm" :disabled="true" />
          <StoRadio step="vacuumPanels" :type="`novip_`+elementForm" />
        </div>
      </div>
    </div>
    <div class="info-wrapper">
      <div v-if="elementForm === 'jak' || elementForm === 'jakp'">
        <p class="variable"> <span v-html="$t(`variablesNice.w`)"></span> : {{w}} mm </p>
        <p class="variable"> <span v-html="$t(`variablesNice.c`)"></span> : {{c}} mm </p>
        <div v-if="$store.state.calculatorData.errors['w'] == 'min'" class="col-12 error">
            {{$tc(`globals.errorMin`, min, {min: calculatorMin.w()})}}
          </div>
          <div v-if="$store.state.calculatorData.errors['w'] == 'max'" class="col-12 error">
            {{$tc(`globals.errorMax`, max, {max: calculatorMax.w()})}}
          </div>
        <div v-if="$store.state.calculatorData.warnings.vacuumPanels">
          <p v-if="$store.state.calculatorData.warnings.vacuumPanels.wIsToSmall" class="info" v-html="$t('vacuumPanels.triggerInfo1')"></p>
          <p v-if="$store.state.calculatorData.warnings.vacuumPanels.cIsToSmall" class="info" v-html="$t('vacuumPanels.triggerInfo2')"></p>
        </div>
      </div>
      <div v-else>
        <p class="info" v-html="$t('vacuumPanels.triggerInfoOnlyJAKandJAKP')"></p>
      </div>
    </div>
     <StepNavi thisPage="6" :key="`navi_tab6_`+ $store.state.calculatorData.calculatorPages[6].disabled"/>
  </div>
</template>

<script>
import StoRadio from './StoRadio.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'VacuumPanels',
  components: {
    StoRadio,
    StepNavi
  },
  data () {
    return {
      min: 0,
      max: 0,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'w',
      'c',
      'elementForm',
      'calculatorMin',
      'calculatorMax'
    ])
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'vacuumPanels'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- VacuumPanels rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
